"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Chip = exports.Chips = exports.Inner = exports.Wrapper = exports.InputWrapper = exports.SearchInputWrapper = exports.Input = exports.Label = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _TextInput = _interopRequireDefault(require("../TextInput"));

var _textStyles = require("../../styles/textStyles");

var Label = _styled.default.label(function (_ref) {
  var space = _ref.theme.space;
  return {
    marginBottom: space.xsmall
  };
});

exports.Label = Label;
var Input = (0, _styled.default)(_TextInput.default)(function (_ref2) {
  var space = _ref2.theme.space;
  return {
    height: space.xxlarge,
    paddingLeft: space.base,
    border: 'none !important' // required to override default TextInput styling.

  };
});
exports.Input = Input;

var SearchInputWrapper = _styled.default.div(function () {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  };
});

exports.SearchInputWrapper = SearchInputWrapper;

var InputWrapper = _styled.default.div(function (_ref3) {
  var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      space = _ref3$theme.space,
      colors = _ref3$theme.colors;
  return {
    backgroundColor: colors.white,
    border: "1px solid ".concat(colors.black),
    borderRadius: isFocused ? "".concat(space.small, " ").concat(space.small, " 0 0") : space.small,
    borderBottomColor: isFocused ? colors.none : colors.black,
    overflow: 'hidden'
  };
});

exports.InputWrapper = InputWrapper;

var Wrapper = _styled.default.div(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      space = _ref4$theme.space,
      colors = _ref4$theme.colors;
  return {
    position: 'absolute',
    top: '100%',
    left: 0,
    width: '100%',
    padding: "0 ".concat(space.base, " ").concat(space.base),
    backgroundColor: colors.white,
    border: "1px solid ".concat(colors.black),
    borderRadius: "0 0 ".concat(space.small, " ").concat(space.small),
    borderTopWidth: 0
  };
});

exports.Wrapper = Wrapper;

var Inner = _styled.default.div(function (_ref5) {
  var _ref5$theme = _ref5.theme,
      space = _ref5$theme.space,
      colors = _ref5$theme.colors;
  return {
    borderTop: "1px solid ".concat(colors.black),
    paddingTop: space.small
  };
});

exports.Inner = Inner;

var Chips = _styled.default.div(function () {
  return {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start'
  };
});

exports.Chips = Chips;

var Chip = _styled.default.div(function (_ref6) {
  var _ref6$theme = _ref6.theme,
      space = _ref6$theme.space,
      colors = _ref6$theme.colors;
  return _objectSpread(_objectSpread({
    marginRight: space.base,
    padding: "".concat(space.small, " ").concat(space.base),
    backgroundColor: colors.offwhite,
    borderRadius: space.small,
    minWidth: space.xxlarge,
    textAlign: 'center',
    cursor: 'pointer',
    marginTop: space.small
  }, _textStyles.bodySize.xsmall), {}, {
    '&:hover': {
      backgroundColor: colors.greymid
    }
  });
});

exports.Chip = Chip;